/**
 * @author 3173
 * @description 岗位能力管理
 * @Date  2020/7/17
 */
import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateCofig } from "./config";
import { WizTableForm } from '../../../common'
import { component_tool, framework_tool, utils_tool } from '../../../../tool';
import AbilityItemEditList from './abilityItemEditList'

let { WizContainer, modelUtils } = framework_tool;
let { WizCard, WizForm, WizSpin, WizModal } = component_tool;
let { Session } = utils_tool

const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1, organizationNodeCategory: ["2"] } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })


class AbilityCheckCategoryDetail extends WizContainer {
  componentName = 'abilityCheckCategoryDetail';

  constructor(props) {
    super(props);
    const { history } = props;
    let initialValue = {};
    let positionState = 1;
    let cardTitle = '新增'
    if (history.location && history.location.pathname === '/train/abilityCheckCategory/categoryDetailUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        positionState = initialValue.state;
        Session.set('categoryDetailUpd', initialValue)
      } else {
        initialValue = Session.get('categoryDetailUpd') || {};
      }
      cardTitle = '编辑'
    }
    this.state = {
      cardTitle: cardTitle
    }
    this.initialValue = initialValue;
  }


  _componentDidMount() {
    //获取能力项
    if (this.initialValue.id) {
      this.doActions([
        {
          path: 'abilityItem/listByCondition',
          payload: {
            key: 'abilityItemList',
            apiParams: {
              abilityCheckCategoryId: this.initialValue.id
            }
          },
        }
      ])
    }
  }


  propsAndStateOnChange = {
    saveAbilityCheckCategory: this._saveAbilityCheckCategoryOver.bind(this),
    abilityItemList: this.getAbilityItemListOver.bind(this)
  }


  _saveAbilityCheckCategoryOver(nextProps, nextState) {
    if (nextProps.saveAbilityCheckCategory.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/train/abilityCheckCategory');
    } else {
      wizNotice.error('提交失败：' + nextProps.saveAbilityCheckCategory.msg);
    }
    return true;
  }


  getAbilityItemListOver(nextProps, nextState) {
    let _list = [];
    if (nextProps['abilityItemList'] && nextProps['abilityItemList']['success'] === true) {
      let list = nextProps["abilityItemList"]['data'];
      list && list.forEach(val => {
        _list.push({ id: val['id'], state: val['state'], key: val['id'], name: val['name'], exhibition: val['exhibition'] })
      });
      this.initialValue.abilityItemsInfo = _list;
      return true;
    } else {
      wizNotice.error(nextProps["abilityItemList"]['msg'])
      return false;
    }
  }


  /**
   * 保存/更新
   * @param values
   * @private
   */
  _saveAbilityCheckCategory(values) {

    if (this.initialValue.state === 1 && values.state === 0) {
      let content = "岗位能力认证禁用后，学员端将不再展示该岗位能力认证信息，确认禁用吗？"
      WizModal.confirm({
        title: '注意', content,
        onOk: () => {
          this._save(values);
        },
        onCancel() {
        }
      });
    }else{
      this._save(values);
    }


    //let fitterValues = this.fitterFieldsValue(values)

  }

  _save(values) {
    const { history } = this.props;
    let apiPath = "abilityCheckCategory/add";
    if (this.initialValue.id) {
      apiPath = "abilityCheckCategory/update"
    }
    this.doAction({
      path: apiPath,
      payload: {
        key: "saveAbilityCheckCategory",
        apiParams: {
          ...values
        }
      }
    });
  }


  // fitterFieldsValue(fieldsValue) {
  //   let fitterValues = {};
  //   Object.keys(fieldsValue).forEach(key => {
  //     const value = fieldsValue[key];
  //   });
  //   return fitterValues;
  // }

 /**品牌编辑展示框 */
 renderValue(value, valueRows) {
  return (
      <div>  {valueRows && valueRows[0] && valueRows[0].name ? valueRows[0].name : ''}</div>
  )
}


  _render() {
    const { abilityCheckCategoryLoading, abilityItemLoading } = this.props;
    let { cardTitle } = this.state;

    let columns = [
      {
        formItem: {
          type: "hidden",
          initialValue: this.initialValue.id
        },
        name: "id"
      },
      {
        title: "品牌",
        name: "orgId",
        formItem: {
          diy: WizTableForm,
          selectType: "radio",
          ...organizationConfig,
          renderValue: this.initialValue.id?this.renderValue.bind(this):undefined,
          initialValue: this.initialValue.orgId,
          initRows: this.initialValue.orgInfo ? [this.initialValue.orgInfo] : [],
          rules: [{
            required: true,
            message: '请选择品牌',
          }]
        }
      },

      {
        title: "岗位",
        name: "positionIds",
        formItem: {
          diy: WizTableForm,
          ...positionConfig,
          initialValue: this.initialValue.positionIds,
          initRows: this.initialValue.positionInfo ? this.initialValue.positionInfo : [],
          rules: [{
            required: true,
            message: '请选择岗位',
          }]
        }
      },

      {
        title: "能力考核项目",
        name: "name",
        formItem: {
          maxlength: 20,
          placeholder: '能力考核项目最多输入20个字',
          rules: [{
            required: true,
            message: '请输入能力考核项目',
          }],
          initialValue: this.initialValue.name
        },
      },

      {
        title: "能力项",
        name: "abilityItems",
        formItem: {
          type: 'diy',
          diy: AbilityItemEditList,
          initialValue: this.initialValue.abilityItemsInfo ? this.initialValue.abilityItemsInfo : [],
          rules: [{
            required: true,
            message: '请添加能力项',
          }]
        }
      },


      {
        title: "状态",
        name: "state",
        dataIndex: "state",
        dict: [
          { code: 1, codeName: '有效' },
          { code: 0, codeName: '无效' }
        ],
        formItem: {
          initialValue: this.initialValue.state || this.initialValue.state == 0 ? this.initialValue.state : 1,
          type: 'radio',
          rules: [{
            required: true,
            message: '请选择状态',
          }],
        }
      }

    ]


    let onSubmit = this._saveAbilityCheckCategory.bind(this);

    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      }
    }



    return <WizCard>
      <WizSpin tip={'加载中'} spinning={abilityCheckCategoryLoading || abilityItemLoading}>
        <WizForm key='abilityForm' className={'form-inline'} {...formProps} />
      </WizSpin>
    </WizCard>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { abilityCheckCategory, abilityItem } = state;
  const saveAbilityCheckCategory = modelUtils.getModelEntity(abilityCheckCategory, "saveAbilityCheckCategory");
  const abilityItemList = modelUtils.getModelEntity(abilityItem, "abilityItemList");
  const load = modelUtils.getLoadingState(state, ['abilityCheckCategory', 'abilityItem']);
  return {
    abilityItemList,
    saveAbilityCheckCategory,
    ...load
  }
};

export default connect(mapStateToProps)(AbilityCheckCategoryDetail);
